import { render, staticRenderFns } from "./AnnualLeaveApproveForm.vue?vue&type=template&id=c050cfdc&"
import script from "./AnnualLeaveApproveForm.vue?vue&type=script&lang=js&"
export * from "./AnnualLeaveApproveForm.vue?vue&type=script&lang=js&"
import style0 from "./AnnualLeaveApproveForm.vue?vue&type=style&index=0&id=c050cfdc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports